import React, { useEffect, useState } from 'react';
import './Événements.css';
import Hero from '../Hero/Hero';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import { jwtDecode } from 'jwt-decode';

const Événements = ({ renderHero }) => {
  const [events, setEvents] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [part, setPart] = useState(false);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(true);

  const { token } = useAuth();

  // Check user role
  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      if (decodedToken.role === 'user') {
        setId(decodedToken.userId);
        setPart(true);
      }
    }
  }, [token]);

  // Fetch available years from backend
  const fetchAvailableYears = async () => {
    try {
      const response = await axios.get('https://ftlm.org.tn/evennements/years');
      // Sort years descending (recent first)
      const sortedYears = response.data.sort((a, b) => b - a);
      setYears(sortedYears);

      // Set most recent year as selected
      if (sortedYears.length > 0) {
        setSelectedYear(sortedYears[0]);
        fetchEventsByYear(sortedYears[0]);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching years', error);
      setLoading(false);
    }
  };

  // Fetch events for a specific year
  const fetchEventsByYear = async (year) => {
    setLoading(true);
    try {
      const response = await axios.get(`https://ftlm.org.tn/evennements/year/${year}`, {
        responseType: 'json',
      });

      const formattedEvents = await Promise.all(
        response.data.map(async (event) => {
          try {
            const imgResponse = await axios.get(`https://ftlm.org.tn/evennements/${event.id}`, {
              responseType: 'blob',
            });
            const imageUrl = URL.createObjectURL(imgResponse.data);
            const date = new Date(event.dateheure);
            const formattedDate = date.toLocaleDateString('fr-FR');
            return { ...event, data: imageUrl, formattedDate };
          } catch (error) {
            console.error(`Error loading image for event ${event.id}`, error);
            return { ...event, data: null };
          }
        })
      );

      // Sort events by date descending
      formattedEvents.sort((a, b) => new Date(b.dateheure) - new Date(a.dateheure));

      setEvents(formattedEvents);
    } catch (error) {
      console.error('Error fetching events for year', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch years on mount
  useEffect(() => {
    fetchAvailableYears();
  }, []);

  // Handle year change from dropdown
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);
    fetchEventsByYear(year);
  };

  // Participate in an event
  const participate = (eventId) => {
    axios
      .post(`https://ftlm.org.tn/evennements/${eventId}/participate/${id}`)
      .then(() => alert('Your participation was registered'))
      .catch(() => alert('Your participation failed'));
  };

  return (
    <div className="evenements-pagee">
      {renderHero && <Hero />}
      <div className="filter-container">
        <select onChange={handleYearChange} value={selectedYear} className="year-filter">
          {years.map((year, index) => (
            <option key={index} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="loading-spinner"></div>
      ) : (
        <div className="Publications" id="Publications">
          <div className="events-container">
            {events.map((event, index) => (
              <div key={index} className="event-card">
                <h1 className="event-year">{event.formattedDate}</h1>
                <div className="event-details">
                  <h2 className="event-title">{event.title}</h2>
                  {event.data ? (
                    <img src={event.data} alt={`Event ${index + 1}`} className="event-image" />
                  ) : (
                    <div className="event-image placeholder">Loading Image...</div>
                  )}
                  <p className="event-description">{event.description}</p>
                </div>
                {part && (
                  <button
                    onClick={() => participate(event.id)}
                    style={{ backgroundColor: 'black', color: 'white', width: '50%' }}
                  >
                    Participate
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Événements;
